import { render } from "./HeroiconsOutlineIdentification.vue?vue&type=template&id=68fb8fdf"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineIdentification.vue"]])

export default __exports__